module.exports = __webpack_public_path__ + "img/BankofAmerica.b8f157bb.svg";